import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallPriceScenario } from "@circle-react/types";
import { BadgeV2 } from "@circle-react-shared/uikit/BadgeV2";
import type { PriceScenariosProps } from "../types";

interface StatusBadgeProperty {
  labelLocale: string;
  className: string;
  labelClassName: string;
}

const statusBadgeProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    labelLocale: "price_badge.free_trial",
    className: "!bg-blue-100 px-2",
    labelClassName: "!text-blue-800 font-medium",
  },
  trial_then_upfront_then_value: {
    labelLocale: "price_badge.free_trial",
    className: "!bg-blue-100 px-2",
    labelClassName: "!text-blue-800 font-medium",
  },
  upfront_then_trial_then_value: {
    labelLocale: "price_badge.paid_trial",
    className: "!bg-tertiary text-dark px-2",
    labelClassName: "!text-primary font-medium",
  },
  value: null,
  upfront_then_value: null,
};

export const Badge = ({ price }: PriceScenariosProps) => {
  const property = statusBadgeProperties[price.scenario];

  if (property) {
    return (
      <BadgeV2
        label={t([property.labelLocale], { count: price.trial_days })}
        className={classNames("rounded-md border-0", property.className)}
        labelClassName={property.labelClassName}
        textSizeClassName="text-xs"
      />
    );
  }

  return null;
};
